import React, { FC } from 'react';
import { useSeparator } from 'react-aria';

interface SeparatorProps {
    className: string;
}

export const Separator: FC<SeparatorProps> = ({ className }) => {
    const { separatorProps } = useSeparator({
        elementType: 'div',
    });

    return <div {...separatorProps} className={className} />;
};
